import React from 'react';
import styled from '@emotion/styled';
import Layout from '@/components/common/layout';
import GarageHeader from '@/components/fakeDoor/components/garageHeader';
import CallBackCard from '@/components/fakeDoor/components/callBackCard';
import HelpFAQ from '@/components/fakeDoor/components/helpFAQ';
import useOnce from '@/hooks/useOnce';
import { getMMVDetails } from '@/components/fakeDoor/utils';
import { viewPageAPI } from '@/analytics/middleware';
import { VIEW_PAGE_ADSC_HELP_CALL } from '@/analytics/events';

const CustomLayout = styled(Layout)`
    .layoutWrapper {
        padding: 0;
        @media (max-width: 700px) {
            overflow-y: auto;
        }
    }
`;
export default function ScheduleCallBack() {
    const showHelp: boolean = false;
    useOnce(() => {
        viewPageAPI({
            event_name: VIEW_PAGE_ADSC_HELP_CALL,
            customAttributes: {
                ...getMMVDetails(),
                adsc_price_seen:
                    localStorage.getItem('price-seen') === 'true'
                        ? true
                        : false,
            },
            isFakeDoor: true,
        });
    });
    return (
        <>
            {' '}
            <CustomLayout hideDesktopHeader hideMobileHeader>
                <div className="container">
                    <div className="heading">
                        <GarageHeader showOnlyBackCTA />
                        <div>How can we help you?</div>
                    </div>
                    <CallBackCard />
                </div>
                <HelpFAQ />
            </CustomLayout>
            <style jsx>{`
                .container {
                    font-family: 'Euclid Circular B';
                    padding: 0 20px 20px 20px;
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    height: max-content;
                    background-color: #efe9fb;
                }
                .heading {
                    display: flex;
                    flex-direction: column;
                    color: var(--Text-Primary-grey600, #121212);
                    font-family: 'Euclid Circular B';
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 28px; /* 140% */
                    letter-spacing: -0.1px;
                }
            `}</style>
        </>
    );
}
